/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Reject_Title1Inputs */

const vi_driverremittance_reject_title1 = /** @type {(inputs: Driverremittance_Reject_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ chối phiếu nộp quỹ`)
};

/**

* @param {Driverremittance_Reject_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_reject_title1 = /** @type {((inputs?: Driverremittance_Reject_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Reject_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_reject_title1(inputs)
});
export { driverremittance_reject_title1 as "driverRemittance_reject_title" }